// app/pages/CentreManager/reducer.ts
import {
  FETCH_CENTRES,
  SET_CENTRES,
  SAVE_CENTRE_REQUEST,
  SAVE_CENTRE_SUCCESS,
  SAVE_CENTRE_FAILURE,
  CENTRE_SET_FILTER,
  CENTRE_SET_SHOW_ALL,
  CENTRE_MODAL_OPEN,
  CENTRE_MODAL_CLOSE,
  Centre,
} from './actions';

export interface CentreState {
  list: Centre[];
  loading: boolean;
  saving: boolean;
  error?: string;
  filterName: string;
  showAll: boolean;
  modalOpen: boolean;
  editing: Centre | null;
}

const initialState: CentreState = {
  list: [],
  loading: false,
  saving: false,
  error: undefined,

  filterName: '',
  showAll: false,
  modalOpen: false,
  editing: null,
};

export default function centreManagerReducer(
  state: CentreState = initialState,
  action: any
): CentreState {
  switch (action.type) {
    case FETCH_CENTRES:
      return { ...state, loading: true, error: undefined };

    case SET_CENTRES:
      return { ...state, loading: false, list: action.payload ?? [] };

    case SAVE_CENTRE_REQUEST:
      return { ...state, saving: true, error: undefined };

    case SAVE_CENTRE_SUCCESS:
      return { ...state, saving: false };

    case SAVE_CENTRE_FAILURE:
      return { ...state, saving: false, error: action.error };

    case CENTRE_SET_FILTER:
      return { ...state, filterName: action.payload ?? '' };

    case CENTRE_SET_SHOW_ALL:
      return { ...state, showAll: !!action.payload };

    case CENTRE_MODAL_OPEN:
      return { ...state, modalOpen: true, editing: action.payload ?? null };

    case CENTRE_MODAL_CLOSE:
      return { ...state, modalOpen: false, editing: null };

    default:
      return state;
  }
}
